import { STORE } from "@/constants/testIds";

export const NAV_LINKS = [
  { to: "/", label: "Home", testId: STORE.navHomeLink, end: true },
  { to: "/product", label: "Study Platform", testId: STORE.navProductLink },
  { to: "/diagnostic", label: "Free Diagnostic", testId: STORE.navDiagnosticLink },
  { to: "/preview", label: "Free Preview", testId: STORE.navPreviewLink },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ", testId: STORE.navFaqLink },
  { to: "/study/login", label: "Sign in" },
  { to: "/contact", label: "Contact", testId: STORE.navContactLink },
];

// The full list remains available in the mobile menu. The desktop bar stays
// intentionally focused so labels never compete with the primary purchase CTA.
export const DESKTOP_NAV_LINKS = [
  { to: "/product", label: "Study Platform", testId: STORE.navProductLink },
  { to: "/diagnostic", label: "Free Diagnostic", testId: STORE.navDiagnosticLink },
  { to: "/preview", label: "Preview", testId: STORE.navPreviewLink },
  { to: "/faq", label: "FAQ", testId: STORE.navFaqLink },
  { to: "/study/login", label: "Sign in" },
];
